
import React from 'react';

interface PerformanceScoreProps {
  metrics: {
    firstContentfulPaint?: number;
    timeToInteractive?: number;
    loadComplete?: number;
  };
}

const PerformanceScore: React.FC<PerformanceScoreProps> = ({ metrics }) => {
  // Simple heuristic to calculate approximate performance score
  // Based on First Contentful Paint, TTI and Load Complete times
  const fcp = metrics.firstContentfulPaint || 0;
  const tti = metrics.timeToInteractive || 0;
  const load = metrics.loadComplete || 0;
  
  let score = 100;
  
  // Reduce score based on critical metrics
  if (fcp > 2000) score -= 20;
  else if (fcp > 1000) score -= 10;
  
  if (tti > 3500) score -= 25;
  else if (tti > 2000) score -= 15;
  
  if (load > 5000) score -= 20;
  else if (load > 3000) score -= 10;
  
  // Performance score color
  let scoreColor = 'bg-green-500';
  if (score < 50) scoreColor = 'bg-red-500';
  else if (score < 70) scoreColor = 'bg-yellow-500';
  else if (score < 90) scoreColor = 'bg-green-400';
  
  return (
    <div className="flex items-center gap-2">
      <div className="w-24 bg-gray-200 rounded-full h-2">
        <div 
          className={`h-2 rounded-full ${scoreColor}`}
          style={{ width: `${Math.max(score, 5)}%` }}
        ></div>
      </div>
      <span className={`text-sm font-medium ${score >= 90 ? 'text-green-500' : score >= 70 ? 'text-green-400' : score >= 50 ? 'text-yellow-500' : 'text-red-500'}`}>
        {score}
      </span>
    </div>
  );
};

export default PerformanceScore;
